export default __webpack_public_path__ + "0451a8d4842f53a0714d091d6ff7981a.jpg";